import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ng-kernel';
import { IProgram, ITerm } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';

export interface ITermProgramInfoModel {
  term?: ITerm;
  program?: IProgram;
}

export type TermProgramInfoModel = ITypedModel<ITermProgramInfoModel>;

angular.module('capability-ng-scheduler').factory(
  'ngTermProgramInfoModel',
  () =>
    new Model<ITermProgramInfoModel>({
      term: undefined,
      program: undefined
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/models/term_program_info_model.ts